import Icon, { IconNameT } from '@/components/common/Icon.tsx'
import { PopoverProperty } from '@/components/common/propertyPopoverOverlay/Property.tsx'
import { ReactNode } from 'react'

type OptionsT = {
  label: string
  value: string
  iconName?: IconNameT
  children?: PopoverProperty[]
  labelNode?: ReactNode
  mapCode?: string
  disabled?: boolean
  parent?: string
}

export function createPopoverProperty(options: OptionsT): PopoverProperty {
  const { label, value, iconName, children, labelNode, mapCode, disabled, parent } = options

  const property: PopoverProperty = {
    label,
    value,
  }
  if (labelNode) property.labelNode = labelNode
  if (mapCode) property.mapCode = mapCode
  if (iconName) property.icon = <Icon icon={iconName} />
  if (children) property.children = children
  if (disabled) property.disabled = disabled
  if (parent) property.parent = parent

  return property
}
